import React from "react";

import SlideMainTitle from "../slides-components/Title";
import TitleDescription from "../slides-components/TitleDescription";
import SlideWrapper from "../slides-components/SlideWrapper";

const slideData = {
  title: "Quanto costa aprire una partita iva in regime forfettario?",
  description:
    "Ottieni un report personalizzato sui costi che dovrai sostenere per la tua partita IVA in 5 semplici passi",
};

const IntroSlide = ({ urlParameters, navigate, queryString }) => {
  const handleClick = () => {
    const newQueries = {
      ...urlParameters,
      currentStep: 1,
    };
    navigate("/calcolatore/?" + queryString.stringify(newQueries));
  };
  return (
    <SlideWrapper>
      <div className="md:mb-8 flex items-center justify-center flex-col h-full w-full ">
        <SlideMainTitle text={slideData.title} />
        <TitleDescription text={slideData.description} />

        <button
          className="calcolatore-btn-force text-center mt-8 lg:w-[300px] px-4 py-2 text-orange-400 uppercase border border-orange-400 rounded shadow-sm hover:shadow-xl  bg-white  dark:bg-transparent   dark:hover:text-orange-400 duration-200 dark:bg-orange-400 dark:hover:bg-white dark:text-white flex flex-col justify-center items-center"
          onClick={() => handleClick()}
        >
          INIZIA
        </button>
      </div>
    </SlideWrapper>
  );
};

export default IntroSlide;
